import React from 'react';
import { Checkbox, Dialog, FormControl, FormGroup, Grid } from '@mui/material';
import styles from '../../../../../custom/style.module.css';
import { CustomButton, CustomDialogTitle, CustomDialogAction, CustomInputLabel, StyledCard, CustomDialogContent, CustomCheckbox } from '../../../../../custom/components';
import { CloseIconBtn } from 'custom/constants';

const CopyModal = (props) => {
  const { airlines, copyAirline, productField, onChangeProduct } = props;
  return (
    <div>
      <Dialog aria-labelledby='form-dialog-title' open={props.modal === 'copy'} onClose={props.onClose} maxWidth={'sm'} fullWidth>
        <CustomDialogTitle id='form-dialog-title'>
          Copy Product
          <CloseIconBtn onClick={props.onClose} />
        </CustomDialogTitle>
        <form className={styles.w100} onSubmit={copyAirline} onReset={props.onClose}>
          <CustomDialogContent>
            <StyledCard>
              <div>
                <CustomInputLabel htmlFor='ac' required className={`${styles.pb2}`}>Airlines</CustomInputLabel>
                <FormControl component='fieldset' variant='standard'>
                  <FormGroup row                     
                    sx={{
                      marginRight: '-12px',
                      marginLeft: '12px',
                    }}
                  >
                    <Grid container spacing={1}>
                      {airlines.map((type) => (
                        <Grid key={type} item xs={6} md={2} lg={2}>
                          <CustomCheckbox
                            control={
                              <Checkbox
                                checked={productField?.airlines?.includes(type.id)}
                                onChange={onChangeProduct}
                                name={type.code}
                                value={type.id}
                              />
                            }
                            label={type.code}
                          />
                        </Grid>
                      ))}
                    </Grid>
                  </FormGroup>
                </FormControl>
              </div>
            </StyledCard>
          </CustomDialogContent>
          <CustomDialogAction className={`${styles.fSpaceBtw}`}>
            <CustomButton variant='contained' type='reset'> Close </CustomButton>
            <CustomButton variant='contained' type='submit'>Copy</CustomButton>
          </CustomDialogAction>
        </form>
      </Dialog>
    </div>
  );
};
export default CopyModal;